<template>
  <v-textarea
    v-model.trim="value"
    ref="textareaRef"
    :label="label"
    :focused="focused"
    :autofocus="autofocus"
    :no-resize="noResize"
    :rules="rules"
    :readonly="readonly"
    :auto-grow="autoGrow"
    :class="{ 'with-append-inner-slot': !!slots['append-inner'] }"
    class="e-textarea"
    hide-details="auto"
    variant="outlined"
  >
    <template v-if="slots['append-inner']" #append-inner="{ blur }">
      <slot name="append-inner" :blur="blur" />
    </template>
    <template v-if="slots.append" #append>
      <slot name="append" />
    </template>
  </v-textarea>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { VInput } from 'vuetify/components';

defineProps<{
  modelValue: string;
  label?: string;
  autofocus?: boolean;
  focused?: boolean;
  noResize?: boolean;
  readonly?: boolean;
  autoGrow?: boolean;
  rules?: VInput['rules'];
}>();

const slots = defineSlots<{
  'append-inner'?: (props: { blur: () => void }) => void;
  append?: (props: unknown) => void;
}>();

const textareaRef = ref();

const value = defineModel();

defineExpose({
  input: textareaRef,
});
</script>

<style scoped lang="scss">
.e-textarea {
  :deep(.v-field__field) {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      right: 4px;
      bottom: 8px;

      width: 16px;
      height: 16px;

      background: url('@/assets/img/common/resize-icon.svg') no-repeat center center / cover;

      pointer-events: none;
    }
  }

  &.v-textarea--no-resize {
    :deep(.v-field__field) {
      &:after {
        display: none;
      }
    }
  }

  :deep(.v-field__append-inner) {
    position: absolute;
    top: 0;
    right: 12px;
  }

  &.v-input--readonly {
    :deep(button) {
      cursor: pointer !important;

      * {
        cursor: pointer !important;
      }
    }
  }

  :deep(.v-textarea--no-resize) {
    .v-field__field {
      &:after {
        display: none;
      }
    }
  }

  :deep(.v-field__input) {
    margin-bottom: 8px;
    padding: 16px 6px 16px 16px;

    &::-webkit-resizer {
      border: 5px solid transparent;
    }
  }

  &.with-append-inner-slot {
    :deep(textarea) {
      padding-right: 44px;
    }
  }
}
</style>
